import { Component, Prop, Vue } from "vue-property-decorator";
import StackedBar from "./StackedBarChart/StackedBarChart.vue";
import BarChart from "./BarChart/BarChart.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import StackedPolarChart from "./StackedPolarChart/StackedPolarChart.vue";
import StackedRadialChart from "./StackedRadialChart/StackedRadialChart.vue";
import PieChart from "./PieChart/PieChart.vue";
import DoughnutChart from "./DoughnutChart/DoughnutChart.vue";
import StackedLineChart from "./StackedLineChart/StackedLineChart.vue";
import LineChart from "./LineChart/LineChart.vue";
import StackedBarChart from "./StackedBarChart/StackedBarChart.vue";

@Component({
  name: "Charts",
  components: {
    StackedBar,
    BarChart,
    StackedBarChart,
    StackedPolarChart,
    StackedRadialChart,
    PieChart,
    DoughnutChart,
    StackedLineChart,
    LineChart
  }
})
export default class Charts extends Vue {
  @Prop() propertiesToChart!: {
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: DynamicSelectData[];
    chartType: string;
    isHorizontal: boolean;
    chartColor: string;
  };
}
